import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
} from '@/components/common/skeleton';

const FIRST_FIELD_COUNT = 4;
const SECOND_FIELD_COUNT = 2;

export const EditEventSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {Array.from({ length: FIRST_FIELD_COUNT }).map((_, i) => (
      <View key={`f1-${i}`} style={styles.field}>
        <SkeletonBone width={80} height={12} />
        <SkeletonBone width="100%" height={44} borderRadius={8} />
      </View>
    ))}
    <SkeletonBone width={120} height={18} style={styles.sectionHeader} />
    {Array.from({ length: SECOND_FIELD_COUNT }).map((_, i) => (
      <View key={`f2-${i}`} style={styles.field}>
        <SkeletonBone width={80} height={12} />
        <SkeletonBone width="100%" height={44} borderRadius={8} />
      </View>
    ))}
    <View style={styles.actionRow}>
      <SkeletonBone width={80} height={38} borderRadius={8} />
      <SkeletonBone width={100} height={38} borderRadius={8} />
    </View>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingTop: 16,
    gap: 16,
  },
  field: {
    gap: 6,
  },
  sectionHeader: {
    marginTop: 8,
  },
  actionRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 12,
    marginTop: 12,
  },
});
